/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, identity, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { UserListItemDto } from '../../users/user-list-item.dto';
import { JobGeneralTabInfoDto } from './job-general-info.dto';
import { jobGeneralInfoMapper } from './job-general-info.mapper';

@Injectable()
export class JobGeneralInfoRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  changeSupervisor(jobId: ID, supervisor: UserListItemDto): Observable<UserListItemDto> {
    return this.httpPut(
      `${this.bp}/jobs/${jobId}/change-supervisor`,
      supervisor,
      identity(),
    );
  }

  get(jobId: ID): Observable<JobGeneralTabInfoDto> {
    return this.httpGet(
      `${this.bp}/jobs/${jobId}/general-info`,
      jobGeneralInfoMapper,
    );
  }

  update(jobId: ID, info: JobGeneralTabInfoDto): Observable<JobGeneralTabInfoDto> {
    return this.httpPut(
      `${this.bp}/jobs/${jobId}/general-info`,
      info,
      jobGeneralInfoMapper,
    );
  }
}
